export default __webpack_public_path__ + "static/media/logo-lg-2048w.a9883687.png";